import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput, { OutlinedInputProps } from '@mui/material/OutlinedInput';

interface SearchBarPropOptions {
  searchQuery?: string;
  placeholder?: string;
  handleSearch: (inputValue: string) => void;
  cancelSearch?: Function | undefined;
  inputProps?: OutlinedInputProps;
  searchIcon?: React.ReactNode;
  testId?: string;
}

export default function SearchBar({
  searchQuery = '',
  placeholder = 'Search',
  handleSearch,
  cancelSearch = undefined,
  inputProps = {},
  searchIcon = <SearchIcon />,
  testId = 'search-bar',
}: SearchBarPropOptions) {
  return (
    <FormControl variant="outlined" data-testid={testId}>
      <OutlinedInput
        size="small"
        value={searchQuery}
        onChange={(event) => handleSearch(event.target.value)}
        placeholder={placeholder}
        endAdornment={
          <InputAdornment position="end">
            {searchQuery ? (
              <IconButton
                onClick={() => {
                  if (cancelSearch) return cancelSearch();
                  handleSearch('');
                }}
                type="submit"
                aria-label="search"
                edge="end"
              >
                <ClearIcon />
              </IconButton>
            ) : (
              <IconButton type="submit" aria-label="search" edge="end">
                {searchIcon}
              </IconButton>
            )}
          </InputAdornment>
        }
        {...inputProps}
      />
    </FormControl>
  );
}
